"use client"

import { useField, useFormikContext } from "formik"
import { ChannelSelect, type SelectableChannel } from "@/components/notification-channels/channel-select"

type FormChannelSelectProps = {
  name: string
  options: SelectableChannel[]
  /** Shown when nothing is selected — the caller says what the fallback actually is. */
  emptyLabel: string
  disabled?: boolean
  loading?: boolean
}

export function FormChannelSelect({
  name,
  options,
  emptyLabel,
  disabled,
  loading,
}: FormChannelSelectProps) {
  const [field] = useField<string[]>(name)
  const { setFieldValue, setFieldTouched } = useFormikContext()

  return (
    <ChannelSelect
      options={options}
      value={field.value}
      onChange={(ids) => {
        void setFieldValue(name, ids)
        void setFieldTouched(name, true, false)
      }}
      emptyLabel={emptyLabel}
      disabled={disabled}
      loading={loading}
    />
  )
}
